/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import './CustomAddActionCard.css';
import { themes, fonts } from '../../themes/themes';
import { check_user_permission } from '../../configs/utils';
import { useAppSelector } from '../../../infra/hooks';
import YearFilterButton from '../YearFilterButton/YearFilterButton';
import { useTranslate } from '../../../hooks';
interface ICustomEditCardProps {
  card_title?: string;
  card_subtitle?: string;
  card_height?: string;
  onClick?: () => void;
  onClickEdit?: () => void;
  isAddButton?: boolean;
  showEditButton?: boolean;
  showtypefilter?: boolean;
  leaveType?: string;
  height?: string;
  onfilterhead?: (data: any) => void;
}

const CustomEditCard: React.FC<
  React.PropsWithChildren<ICustomEditCardProps>
> = ({
  children,
  card_title,
  card_height,
  onClick,
  onClickEdit,
  card_subtitle,
  isAddButton = true,
  showEditButton = false,
  showtypefilter = false,
  leaveType,
  height,
  onfilterhead,
}) => {
  const { translate } = useTranslate();
  const auth_permissions = useAppSelector(
    (state: any) => state.authPermissionSlice?.authPermission,
  );
  return (
    <div
      className="customAddActionCard"
      style={{
        maxHeight: card_height,
        height: height ?? 'auto',
        overflowY: 'auto'
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Grid
            item
            xs={5}
            style={{
              justifyContent: 'right',
            }}
          >
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography
                style={{
                  color: themes.blackDefault,
                  fontSize: fonts.header,
                  fontWeight: 'bold',
                }}
              >
                {card_title}
              </Typography>
              {showEditButton && (
                <Box className="edit-style" onClick={onClickEdit}>
                  {' '}
                  <i className="las la-pencil-alt" />{' '}
                </Box>
              )}
            </Box>
            <Typography
              style={{
                color: themes.defaultIcon,
                fontSize: fonts.subtitle,
                fontFamily: fonts.fontFamily,
              }}
            >
              {card_subtitle}
            </Typography>
          </Grid>

          {showtypefilter ? (
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
              }}
            >
              <YearFilterButton
                menu={[
                  {
                    id: 'Leaves',
                    label: translate('Leaves'),
                    color: '#7C0E6F',
                  },
                  {
                    id: 'Leave Advance',
                    label: translate('Leave Advance'),
                    color: '#7C0E6F',
                  },
                  {
                    id: 'Leave Encashment',
                    label: translate('Leave Encashment'),
                    color: '#7C0E6F',
                  },
                ]}
                onSelect={onfilterhead}
                title={translate(leaveType ?? '')}
              />
            </Grid>
          ) : (
            ''
          )}
          <Grid
            item
            xs={2}
            style={{
              display: 'flex',
              justifyContent: 'right',
            }}
          >
            {check_user_permission(auth_permissions, isAddButton, 'add') && (
              <Box className="add-icon" onClick={onClick}>
                <i className="las la-plus icon" />
              </Box>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Box className="card__scrollbar" style={{ paddingBottom: '0.1em' }}>
        {children}
      </Box>
    </div>
  );
};

export default CustomEditCard;
